import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* 中文版 */
import common from '../views/common/index'
import index from '../views/index/index'
import about from '../views/about/index'
import article from '../views/article/index'
import articleDetails from '../views/article-details/index'
import expert from '../views/expert/index'
import expertDetails from '../views/expert-details/index'

import book from '../views/book/index'
import bookDetails from '../views/book-details/index'
import magazine from '../views/magazine/index'
import magazineDetails from '../views/magazine-details/index'
import magazinePreview from '../views/magazine-preview/index'
import magazineCart from '../views/magazine-cart/index'
import magazineCartOrder from '../views/magazine-cart-order/index'
import magazineOrder from '../views/magazine-order/index'
import magazineOrderInfo from '../views/magazine-order-info/index'
import magazineFali from '../views/magazine-fail/index'
import memberCenter from '../views/member-center/index'
import aa from '../views/aa/index'
import Order from '../views/order/index.vue'
import OrderSingle from '../views/order/single.vue'
import Pay from '../views/pay/index.vue'
import story from '../views/story/index'
import video from '../views/video/index'
import videoDetails from '../views/video-details/index'
import wxMobile from '../views/wx-mobile/index'
import bookPreview from '../views/book-preview/index'
import home from '../views/home/index'
import test from '../views/test/index'
import testPrerender from '../views/test-prerender/index'
/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  //{ path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/center', component: () => import('@/views/center/index'), hidden: true },
  { path: '/share', component: () => import('@/views/share/index'), hidden: true },
  // {
  //   path: '/',
  //   redirect: '/',
  // },
  // {
  //   path: '/aa',
  //   component: aa,

  // {
  //   path: '/',
  //   component: index,
  //   name: 'home',
  //   meta: {
  //     title: '首页',
  //     keepAlive: true
  //   }
  // },
  // {
  //   path: '/test',
  //   component: test,
  //   name: 'test',
  //   meta: {
  //     title: '关于',
  //     keepAlive: false
  //   }
  // },
  // },
  // {
  //   path: '/',
  //   component: common,
  //   name:'common',
  //   meta: {
  //     title: '台商雜誌',
  //     keepAlive: true
  //   },
  //   children: [ // 此级别组件将显示在header下面和侧边栏右边的区域
  {
    path: '/',
    component: index,
    name: 'index',
    meta: {
      title: '首页',
      keepAlive: true
    }
  },
  {
    path: '/article',
    component: article,
    name: 'article',
    meta: {
      title: '文章列表',
      keepAlive: true
    }
  },
  {
    path: '/story',
    component: story,
    name: 'story',
    meta: {
      title: '故事專訪',
      keepAlive: true
    }
  },
  {
    path: '/video',
    component: video,
    name: 'video',
    meta: {
      title: '影音視頻',
      keepAlive: true
    }
  },
  {
    path: '/video-details/:id',
    component: videoDetails,
    name: 'videoDetails',
    meta: {
      title: '影音視頻详情',
      keepAlive: false
    }
  },
  {
    // path: '/article-details/:id',
    path: '/:slug.html',
    component: articleDetails,
    name: 'articleDetails',
    meta: {
      title: '文章详情',
      keepAlive: false
    }
  },
  {
    path: '/expert',
    component: expert,
    name: 'expert',
    meta: {
      title: '名家专栏',
      keepAlive: true
    }
  },
  {
    path: '/expert-details/:id',
    component: expertDetails,
    name: 'expertDetails',
    meta: {
      title: '名家专栏详情',
      keepAlive: false
    }
  },

  {
    path: '/book',
    component: book,
    name: 'book',
    meta: {
      title: '電子書閱讀',
      keepAlive: true
    }
  },
  {
    path: '/book-details/:id',
    component: bookDetails,
    name: 'bookDetails',
    meta: {
      title: '電子書閱讀',
      keepAlive: false
    }
  },
  {
    path: '/magazine',
    component: magazine,
    name: 'magazine',
    meta: {
      title: '電子書閱讀',
      keepAlive: true
    }
  },
  {
    path: '/magazine-details/:id',
    component: magazineDetails,
    name: 'magazineDetails',
    meta: {
      title: '電子書閱讀',
      keepAlive: false
    }
  },
  {
    path: '/magazine-cart',
    component: magazineCart,
    name: 'magazineCart',
    meta: {
      title: '購物清單',
      keepAlive: false
    }
  },
  {
    path: '/magazine-cart-order',
    component: magazineCartOrder,
    name: 'magazineCartOrder',
    meta: {
      title: '購物車結算',
      keepAlive: false
    }
  },
  {
    path: '/magazine-order/:id',
    component: magazineOrder,
    name: 'magazineOrder',
    meta: {
      title: '填寫訂購資料',
      keepAlive: false
    }
  },
  {
    path: '/magazine-order-info',
    component: magazineOrderInfo,
    name: 'magazineOrderInfo',
    meta: {
      title: '您的訂單資訊',
      keepAlive: false
    }
  },
  {
    path: '/magazine-fail',
    component: magazineFali,
    name: 'magazineFali',
    meta: {
      title: '您的訂單付款失敗',
      keepAlive: false
    }
  },
  {
    path: '/member-center',
    component: memberCenter,
    name: 'memberCenter',
    meta: {
      title: '電子書閱讀',
      keepAlive: false
    }
  },
  {
    path: '/about',
    component: about,
    name: 'about',
    meta: {
      title: '关于',
      keepAlive: false
    }
  },
  {
    path: '/test-prerender',
    component: testPrerender,
    name: 'testPrerender',
    meta: {
      title: '预渲染测试',
      keepAlive: false
    }
  },

  {
    path: '/order',
    component: Order,
    name: 'order',
    meta: {
      title: ('下单'),
      keepAlive: false
    }
  },
  {
    path: '/order-single/:id',
    component: OrderSingle,
    name: 'orderSingle',
    meta: {
      title: ('单期下单'),
      keepAlive: false
    }
  },
  {
    path: '/pay',
    component: Pay,
    name: 'pay',
    meta: {
      title: ('付款'),
      keepAlive: false
    }
  },
  {
    path: '/wx-mobile',
    component: wxMobile,
    name: 'wxMobile',
    meta: {
      title: ('微信掃碼'),
      keepAlive: false
    }
  },
  {
    path: '/book-preview',
    component: bookPreview,
    name: 'bookPreview',
    meta: {
      title: '電子書閱讀',
      keepAlive: false
    }
  },
    // ]
  // },

  {
    path: '/magazine-preview',
    component: magazinePreview,
    name: 'magazinePreview',
    meta: {
      title: '電子書閱讀',
      keepAlive: true
    }
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  mode: 'history', // 临时切换到 hash 模式测试预渲染
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js